export default "__VITE_ASSET__8e400222__"